import { Box } from "@mui/material";
import { ReactNode } from "react";

interface ScrollableFormContainerProps {
  children: ReactNode;
  maxHeight: string | number;
  mobileMaxHeight?: string | number;
}

export const ScrollableFormContainer = ({
  children,
  maxHeight,
  mobileMaxHeight = 254,
}: ScrollableFormContainerProps) => {
  return (
    <Box
      sx={{
        maxHeight: { xs: `calc(100dvh - ${mobileMaxHeight}px)`, lg: maxHeight },
        overflowY: "auto",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        pr: 1,
      }}
    >
      {children}
    </Box>
  );
};
